import { DefaultContext, FetchResult, MutationResult, useMutation } from '@apollo/client';

import {
  SetAscProjectApprovalMutation,
  SetAscProjectApprovalMutationVariables,
  SET_ASC_PROJECT_APPROVAL,
  PeriodName,
} from '@neo.tax/shared';

type UseSetAscProjectApprovalProps = {
  context?: DefaultContext;
};

type SetAscProjectApprovalParams = {
  ascProjectId: string;
  fiscalYearId: string;
  periodName: PeriodName;
  comment?: string | null;
};

type UseSetAscProjectApproval = [
  (params: SetAscProjectApprovalParams) => Promise<FetchResult<SetAscProjectApprovalMutation>>,
  MutationResult<SetAscProjectApprovalMutation>,
];

export const useSetAscProjectApproval = ({
  context: contextFromInit,
}: UseSetAscProjectApprovalProps = {}): UseSetAscProjectApproval => {
  const [setAscProjectApprovalMutation, setAscProjectApprovalMutationResult] = useMutation<
    SetAscProjectApprovalMutation,
    SetAscProjectApprovalMutationVariables
  >(SET_ASC_PROJECT_APPROVAL, {
    context: {
      successToast: {
        title: 'Project approved successfully',
      },
      errorToast: {
        title: 'Error approving project',
        description: 'Something unexpected prevented the approval. Please try again.',
      },
      ...contextFromInit,
    },
  });

  const setAscProjectApproval = ({
    ascProjectId,
    comment,
    fiscalYearId,
    periodName,
  }: SetAscProjectApprovalParams): Promise<FetchResult<SetAscProjectApprovalMutation>> =>
    setAscProjectApprovalMutation({
      variables: {
        ascProjectId,
        fiscalYearId,
        periodName,
        setAscProjectApprovalInput: {
          comment: comment ?? null,
        },
      },
    });

  return [setAscProjectApproval, setAscProjectApprovalMutationResult];
};
